function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Accordion } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ProjectBody from './ProjectBody';
import ElsterUploadSection from './ElsterUploadSection';
import AccordionCustomToggle from '@rd-web-markets/shared/dist/util/AccordionCustomToggle';
import GroupOverviewNotesList from './ProjectOverviewNotes/GroupOverviewNotesList';
import { createTimezonedDate } from '@rd-web-markets/shared/dist/util/date';
import ElsterDateUpdate from '@rd-web-markets/market/dist/company/ElsterDateUpdate';
import { SaveButton } from '@rd-web-markets/shared/dist/util/buttons';
import Dropdown from '@rd-web-markets/shared/dist/util/Dropdown';
import elsterQuickUpdatesService from '../../../services/company/elster_quick_updates.service';
const ProjectOverview = _ref => {
  var _elster$version_numbe, _elster$version_numbe2;
  let {
    claimProjectReports,
    financialYear,
    elster,
    setElster,
    fetchAllProjetcs,
    fetchElster,
    fetchCompanyMenu,
    paramForCompanyMenuFetch
  } = _ref;
  const {
    t
  } = useTranslation();
  const [elsterQuickUpdateLoading, setElsterQuickUpdateLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [versionNumber, setVersionNumber] = useState((_elster$version_numbe = elster === null || elster === void 0 ? void 0 : elster.version_number) !== null && _elster$version_numbe !== void 0 ? _elster$version_numbe : 'version_7');
  const {
    quickUpdate
  } = elsterQuickUpdatesService.useCrud(elster === null || elster === void 0 ? void 0 : elster.company_id, setElster, setElsterQuickUpdateLoading);
  const headings = /*#__PURE__*/React.createElement(Row, {
    className: "mt-2"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, t('project')), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, t('elster_project_duration_start')), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, t('elster_project_duration_end')), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, t('bsfz_number')), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, t('timesheet')), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, t('staff_cost')), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, t('contract_research_invoices_and_offers')), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, t('project_documentation')), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, t('change_end_date')), /*#__PURE__*/React.createElement(Col, {
    md: 2
  }, t('date_change_status')));
  const body = claimProjectReports.map((project, index) => {
    return /*#__PURE__*/React.createElement(ProjectBody, {
      project: project,
      key: project.id,
      fetchAllProjetcs: fetchAllProjetcs
    });
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, {
    style: {
      width: '100%',
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Accordion, {
    defaultActiveKey: "0"
  }, /*#__PURE__*/React.createElement(Row, {
    className: "mb-5 align-items-center"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React.createElement(Dropdown, {
    name: "elster_version",
    fieldName: "elster_version",
    label: "elster_version",
    value: versionNumber,
    onChange: setVersionNumber,
    options: [{
      key: 'version_7',
      value: 'version_7',
      text: 'version_7_elster_periods_starting_before_01_01_2024'
    }, {
      key: 'version_8',
      value: 'version_8',
      text: 'version_8_elster_periods_starting_after_31_12_2023'
    }],
    dataTestId: "project_overview_elster_version",
    marginClass: "",
    showNullOption: false
  })), /*#__PURE__*/React.createElement(Col, {
    md: 2
  }, /*#__PURE__*/React.createElement(SaveButton, {
    size: "sm",
    onClick: quickUpdate,
    saveParams: [_objectSpread(_objectSpread({}, elster), {}, {
      version_number: versionNumber
    })],
    disabled: elsterQuickUpdateLoading || versionNumber === ((_elster$version_numbe2 = elster === null || elster === void 0 ? void 0 : elster.version_number) !== null && _elster$version_numbe2 !== void 0 ? _elster$version_numbe2 : 'version_7'),
    loading: elsterQuickUpdateLoading,
    text: t('save')
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 8
  }, /*#__PURE__*/React.createElement("div", {
    onClick: () => setOpen(!open)
  }, /*#__PURE__*/React.createElement(AccordionCustomToggle, {
    eventKey: "0",
    open: open
  }, t('document_upload')))), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("span", {
    style: {
      marginRight: '5px'
    }
  }, t('time_period'), ": ", createTimezonedDate(elster.start_date, true).toCustomLocaleDateString(), " - ", createTimezonedDate(elster.end_date, true).toCustomLocaleDateString()), /*#__PURE__*/React.createElement(ElsterDateUpdate, {
    companyId: elster.company_id,
    elster: elster,
    setLoading: () => {},
    loading: false,
    afterSubmitActions: async () => {
      await fetchElster();
      await fetchAllProjetcs();
      await fetchCompanyMenu(paramForCompanyMenuFetch);
    }
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Accordion.Collapse, {
    eventKey: "0"
  }, /*#__PURE__*/React.createElement(ElsterUploadSection, {
    elster: elster,
    setElster: setElster
  })))), /*#__PURE__*/React.createElement("div", {
    style: {
      overflowX: 'auto',
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: '1300px'
    }
  }, headings, body)), /*#__PURE__*/React.createElement(GroupOverviewNotesList, {
    elster: elster,
    setElster: setElster
  }))));
};
export default ProjectOverview;